import { TFunction } from "i18next";
import { useForm } from "react-hook-form";

import { Button, InputText, Text } from "@pentabd/ui";

import { useUser } from "@hooks/useUser";

import { getAccess } from "@helpers/permissionController";

import { REQUSITION_STATUS } from "@constants/status.inventory";

type Input = {
  [key: string]: number;
};

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  handleApprovedAmount: any,
  status: string,
  handleProcessProduct: any,
) => {
  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  const { register, setValue } = useForm<Input>();

  return [
    {
      id: 1,
      key: "category",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_DETAILS.TABLE.COLUMN.CATEGORY",
      ),
      render: (category: string) => {
        return <Text color="subtitle1">{category ? category : "..."}</Text>;
      },
    },
    {
      id: 2,
      key: "group",
      name: t("INVENTORY_REQUISITION.REQUISITION_DETAILS.TABLE.COLUMN.GROUP"),
      render: (group: string) => {
        return <Text color="subtitle1">{group ? group : "..."}</Text>;
      },
    },
    {
      id: 3,
      key: "name",
      name: t("INVENTORY_REQUISITION.REQUISITION_DETAILS.TABLE.COLUMN.NAME"),
      render: (name: string, row: any) => {
        // const name = language === "en" ? row?.nameEn : row?.nameBn;
        // return <Text color="subtitle1">{name ? name : "..."}</Text>;
        return <Text color="subtitle1">{name ? name : "..."}</Text>;
      },
    },
    {
      id: 4,
      key: "brand",
      name: t("INVENTORY_REQUISITION.REQUISITION_DETAILS.TABLE.COLUMN.BRAND"),
      render: (brand: string) => {
        return <Text color="subtitle1">{brand ? brand : "..."}</Text>;
      },
    },
    {
      id: 5,
      key: "type",
      name: t("INVENTORY_REQUISITION.REQUISITION_DETAILS.TABLE.COLUMN.TYPE"),
      render: (type: string) => {
        return <Text color="subtitle1">{type ? type : "..."}</Text>;
      },
    },
    {
      id: 6,
      key: "requestAmount",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_DETAILS.TABLE.COLUMN.REQUESTED_AMOUNT",
      ),
      render: (requestAmount: number) => {
        return <Text color="subtitle1">{requestAmount}</Text>;
      },
    },
    {
      id: 7,
      key: "stock",
      name:
        getAccess(roles, "REQUISITION_APPROVE") &&
        t("INVENTORY_REQUISITION.REQUISITION_DETAILS.TABLE.COLUMN.STOCK"),
      render: (stock: number) => {
        return getAccess(roles, "REQUISITION_APPROVE") ? (
          <Text color="subtitle1">{stock}</Text>
        ) : null;
      },
    },
    {
      id: 8,
      key: "approvedAmount",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_DETAILS.TABLE.COLUMN.APPROVED_AMOUNT",
      ),
      render: (approvedAmount: number, row: any) => {
        return getAccess(roles, "REQUISITION_APPROVE") ? (
          status !== REQUSITION_STATUS.APPROVED && status !== "REJECTED" ? (
            <InputText
              {...register(`approvedAmount_${row.id}`)}
              value={
                approvedAmount
                  ? approvedAmount
                  : row.stock < row.requestAmount
                  ? row?.stock?.toString()
                  : row?.requestAmount?.toString()
              }
              name="approvedAmount"
              onChange={(e) => {
                if (Number(e.target.value) > 0) {
                  setValue(`approvedAmount__${row.id}`, Number(e.target.value));
                  handleApprovedAmount(row, e.target.value);
                } else {
                  setValue(`approvedAmount__${row.id}`, 0);
                  handleApprovedAmount(row, e.target.value);
                }
              }}
              size="sm"
              placeholder="Enter approved amount"
              type="number"
              controlling
              readOnly={status === REQUSITION_STATUS.APPROVED || row.stock <= 0}
            />
          ) : (
            <Text color="subtitle1">{approvedAmount}</Text>
          )
        ) : (
          <Text color="subtitle1">{approvedAmount}</Text>
        );
      },
    },
    {
      id: 9,
      key: "approvedAmount",
      render: (_: any, row: any) => {
        return getAccess(roles, "REQUISITION_ASSIGN") &&
          status === REQUSITION_STATUS.APPROVED &&
          !row?.isAssign ? (
          <Button
            fill="fill"
            type="primary"
            size="xs"
            onClick={async (e) => {
              handleProcessProduct(row);
            }}
          >
            {t("INVENTORY_REQUISITION.REQUISITION_DETAILS.PROCESS")}
          </Button>
        ) : (
          <></>
        );
      },
    },
  ];
};
